module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/road-cone-664c2f5c53e8bddea98dc603eac0333c.svg";